export default __webpack_public_path__ + "static/media/booking.759d1012.png";